import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    catalogo: []

}
//types
const OBTENER_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO = 'OBTENER_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO'
const AGREGAR_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO = 'AGREGAR_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO'

const ACTUALIZAR_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO = 'ACTUALIZAR_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO'


export const obtenerCatalogoMagueyNombreCientifico = createAsyncThunk(
    OBTENER_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO,
    async () => {
        try {
            const fullUrl = host + `CatalogoMagueyNombreCientifico/obtenerCatalogoNombreCientifico`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarCatalogoMagueyNombreCientifico = createAsyncThunk(
    AGREGAR_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `CatalogoMagueyNombreCientifico/agregarNuevoNombreCientifico`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarCatalogoMagueyNombreCientifico = createAsyncThunk(
    ACTUALIZAR_CATALOGO_NOMBRE_CIENTIFICO_MAGUEY_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `CatalogoMagueyNombreCientifico/actualizarNombreCientifico`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



export const CatalogoMagueyNombreCientificoSlice = createSlice({
    name: 'CatalogoMagueyNombreCientificoSlice',
    initialState: dataInicial,
    reducers: {

    },
    extraReducers: {

        [obtenerCatalogoMagueyNombreCientifico.fulfilled]: (state, { payload }) => {
            state.catalogo = payload.data
        },
        [agregarCatalogoMagueyNombreCientifico.fulfilled]: (state, { payload }) => {

        },
        [actualizarCatalogoMagueyNombreCientifico.fulfilled]: (state, { payload }) => {

        },
    },
})

export const {

} = CatalogoMagueyNombreCientificoSlice.actions
export const CatalogoMagueyNombreCientificoReducer = CatalogoMagueyNombreCientificoSlice.reducer
